<template>
    <div class="deshboard">
        <div class="banner" ref="navList" > 
            <img :src="setImg('banner')" alt="">
        </div>
        <div class="product w">
            <div ref="projectTitle" class="project-title animate__animated" :class="projectTitleClass">
                <Head-title title="产品服务" name="PRODUCT SERVEIS"></Head-title>
            </div> 
            <div class="product-img">
                <Carousel :swiperType="1" :isShowPaginate="true" :autoPlay="true" :swiperData="imgSwiperData">
                </Carousel> 
            </div>
        </div>
        <div class="introduce">
            <div class="w">
                <div ref="projectSecondary" class="animate__animated" :class="projectClass">
                    <Head-title title="便捷、强大、稳定、丰富" name="Product advantages"></Head-title>
                </div> 
                <div class="product-list" ref="projectList">
                    <Product-item v-for="(item,index) in productList" :class="projectList ? item.anmiateClass: ''" :key="index" :currIndex="index" :title="item.title" :des="item.des"></Product-item>
                </div>
            </div>
        </div>
        <div class="work w">
            <div ref="workTitle" class="animate__animated" :class="workClass">
                <Head-title name="cooperative partner" title="合作伙伴"></Head-title>
            </div>  
            <ul class="work-list">
                <li v-for="index in 20" :key="index" class="animate__animated" :class="workAnimatedClass">
                    <img :src="require('../../assets/images/work/logo'+(index)+'.png')" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>  
    import mixin from "@/assets/scripts/index";
    import Carousel from "@/components/carousel";
    import HeadTitle from "@/components/HeadTitle";
    import ProductItem from "@/components/ProductItem"; 
    export default {
        name: 'Dashboard',
        components: { 
            HeadTitle,
            Carousel,
            ProductItem
        },
        mixins: [mixin],
        data() {
            return {
                productList:[{ 
                                 anmiateClass: 'animate__slideInLeft',
                                 title:'对接体系丰富', 
                                 des:'工业互联网<br>星火·链网<br>特色工业互联网平台'
                             },
                             { 
                                 anmiateClass: 'animate__slideInUp',
                                 title:'软硬一体设计', 
                                 des:'强悍硬件<br>多种型号<br>方便快捷'
                             },
                             { 
                                 anmiateClass: 'animate__slideInRight',
                                 title:'数据储存', 
                                 des:'实时计算<br>水平弹性扩容<br>异构数据沉淀'
                             },
                             { 
                                 anmiateClass: 'animate__slideInLeft',
                                 title:'生态闭环', 
                                 des:'从设备层的数据采集到信息系统层的异构数据接入，通过自动化的标识管理接入丰富的表示应用'
                             },
                             { 
                                 anmiateClass: 'animate__slideInDown',
                                 title:'自动化处理', 
                                 des:'从多种层的数据采集到标识管<br>理，省心省力'
                             },
                             { 
                                 anmiateClass: 'animate__slideInRight',
                                 title:'标识应用', 
                                 des:'多种自主研发的标识应用<br>开放的应用市场'
                             }], 
                imgSwiperData:[{
                    url: require('../../assets/images/bg1.jpeg')
                },{
                    url: require('../../assets/images/bg2.jpeg')
                },{
                    url: require('../../assets/images/bg3.jpeg')
                }]
            }
        },
        computed: {
            projectClass() {  
                return this.projectSecondary ? 'animate__bounceInRight' : '';
            }, 
            projectTitleClass() {
                return this.projectTitle ? 'animate__bounceInLeft' : '';
            },
            workClass() {
                return this.workTitle ? 'animate__zoomIn' : '';
            },
            workAnimatedClass() { 
                return this.workAnimated ? 'animate__slideInUp' : '';
            },
            
        },
        methods: { 
            setImg(path) {
                return require(`@/assets/images/${path}.png`)
            }
        },
    }
</script>

<style lang="scss" scoped>   
.deshboard{ 
    .project-title{
        padding:40px 0 7px;
    }
    .product {
        &-img {
            width: 100%;
            height: 460px;
            overflow: hidden;
            .carousel-component{
                position: relative;
                height: 100%;
            } 
        } 
    }
    .introduce{ 
        position: relative;
        margin-bottom: 28px;
        padding-bottom: 104px;
        background: #f7f7f7 ;
        &::after{
            content: "";
            position:absolute;
            left:0;
            bottom:-28px;
            display: block;
            width:100%;
            height: 671px;
            background: url('~@/assets/images/index-bg.png') no-repeat left bottom;
            background-size: 100% 671px;
        }
        .product-list {
            position: relative;
            z-index: 2;
            display: flex;
            flex-wrap: wrap;
            margin: 0 -27px;
            .product-item{
                background: #fff;
                margin-bottom: 58px;
            }
        }
    }
    .work { 
        padding-top:8px;
        margin-bottom: -33px;
        &-list {
            display: flex;
            flex-wrap: wrap; 
            justify-content:space-between;
            li { 
                width: 255px;
                height: 124px;
                margin-bottom: 33px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 13px;
                box-shadow: 1px 1px 1px 2px #ECF5FF;
                overflow: hidden;
                img {
                    cursor: pointer;
                    height: auto;
                    transition: 2s;
                }
                &:hover {
                    img {
                        transform: scale(2);
                    }
                }
                &:nth-child(1) {
                    img {
                        width: 105px;
                        // height: 65px;
                    }
                }
                &:nth-child(2) {
                    animation-duration: 1.25s;
                    img {
                        width: 165px;
                        // height: 25px;
                    }
                }
                &:nth-child(3) {
                    animation-duration: 1.5s;
                    img {
                        width: 185px;
                        // height: 30px;
                    }
                }
                &:nth-child(4) {
                    animation-duration: 1.75s;
                    img {
                        width: 146px;
                        // height: 36px;
                    }
                }
                &:nth-child(5) {
                    animation-duration: 2s;
                    img {
                        width: 100px;
                        // height: 65px;
                    }
                }
                &:nth-child(6) {
                    animation-duration: 2.25s;
                    img {
                        width: 68px;
                        // height: 66px;
                    }
                }
                &:nth-child(7) {
                    animation-duration: 2.5s;
                    img {
                        width: 185px;
                        // height: 40px;
                    }
                }
                &:nth-child(8) {
                    animation-duration: 2.75s;
                    img {
                        width: 167px;
                        // height: 43px;
                    }
                }
                &:nth-child(9) {
                    animation-duration: 3s;
                    img {
                        width: 97px;
                        // height: 44px;
                    }
                }
                &:nth-child(10) {
                    animation-duration: 3.25s;
                    img {
                        width: 161px;
                        // height: 43px;
                    }
                }
                &:nth-child(11) {
                    animation-duration: 3.5s;
                    img {
                        width: 121px;
                        // height: 55px;
                    }
                }
                &:nth-child(12) {
                    animation-duration: 3.75s;
                    img {
                        width: 181px;
                        // height: 60px;
                    }
                }
                &:nth-child(13) {
                    animation-duration: 4s;
                    img {
                        width: 151px;
                        // height: 55px;
                    }
                }
                &:nth-child(14) {
                    animation-duration: 4.25s;
                    img {
                        width: 190px;
                        // height: 44px;
                    }
                }
                &:nth-child(15) {
                    animation-duration: 4.5s;
                    img {
                        width: 169px;
                        // height: 66px;
                    }
                }
                &:nth-child(16) {
                    animation-duration: 4.75s;
                    img {
                        width: 164px;
                        // height: 25px;
                    }
                }
                &:nth-child(17) {
                    animation-duration: 5s;
                    img {
                        width: 207px;
                        // height: 50px;
                    }
                }
                &:nth-child(18) {
                    animation-duration: 5.25s;
                    img {
                        width: 190px;
                        // height: 34px;
                    }
                }
                &:nth-child(19) {
                    animation-duration: 5.5s;
                    img {
                        width: 167px;
                        // height: 61px;
                    }
                }
                &:nth-child(20) {
                    animation-duration: 5.75s;
                    img {
                        width: 151px;
                        // height: 59px;
                    }
                }
            }
        }
    }
}
@media only screen and (max-width: 750px) { 
    .deshboard{
        .project-title{
            padding-top:0px;
        }
        .introduce{
            .product-list{ 
                margin:0;
            } 
        }
        .work-list{
            li{
                width:30%;
                img{
                    width:90% !important;
                }
            }
        }
        .product-img{
            height: 150px;
            .item-img{
                height: 100%;
            }
            
        }
        .introduce{
            padding-bottom: 30px;
        }
        .product-item{
            width:47%;
            padding:30px;
            margin-left: auto;
            margin-right: auto;
            height: auto;
            margin-bottom: 20px !important; 
        }
        
    }
}
</style>
<style lang="scss">
.product {
        &-img {
            width: 100%;
            height: 460px;
            overflow: hidden;
            .carousel-component,
            .swiper-container{
                position: relative;
                height: 100%;
            } 
            .swiper-pagination{
                bottom: 40px;
                width: 100%;
                left: 0;
                display: flex;
                justify-content:center;
                span{
                    margin:0 10px;
                    display: inline-block;
                    width: 15px;
                    height: 15px;
                    border-radius: 50%;
                    background: #fff;
                    &.active{
                        background: #354EAC;
                    }
                }
            }
        }
}
@media only screen and (max-width: 750px) { 
    .product-img{
        .swiper-pagination{
            display: none;
        }
    }
    .deshboard{
        .product-item{
            .img,b{
                margin-bottom: 10px;
            } 
            b{
                font-size:18px;
                height: 18px;
                line-height: 18px;
            }
        }
    }
}
</style>